import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackSubAgentsListOpen } from './trackSubAgentsListOpen';
import { trackUserChatsSelect } from './trackUserChatsSelect';
import { masterFiltersSelector, subAgentsSelector, unreadMessagesCountSelector, userIdSelector } from '../../selectors';
import { EMasterTabs } from '../../types/masterFilters';

export const useChangeTabTracking = (): ((activeTab: EMasterTabs) => void) => {
  // Данные мастера
  const unreadMessagesCount = useSelector(unreadMessagesCountSelector);
  const userId = useSelector(userIdSelector);

  // Данные сотрудника
  const { selectedSubAgentId } = useSelector(masterFiltersSelector);
  const { subAgentsList } = useSelector(subAgentsSelector);

  return React.useCallback(
    (activeTab: EMasterTabs) => {
      // При переключении на "Мои чаты"
      if (activeTab === EMasterTabs.MasterChats) {
        trackUserChatsSelect({ userId, unreadCount: unreadMessagesCount, position: 0, isMine: true });
      }

      // При переключении на "Чаты сотрудников" без выбранного сотрудника
      if (!selectedSubAgentId && activeTab === EMasterTabs.SubAgentsChats) {
        const products = subAgentsList.map((subAgent, index) => ({
          id: subAgent.userId,
          offerType: 'agent',
          position: index + 1,
        }));

        trackSubAgentsListOpen({ source: 'tab', pageNumber: 1, products });
      }

      // При переключении на "Чаты сотрудников" с выбранным сотрудником
      if (selectedSubAgentId && activeTab === EMasterTabs.SubAgentsChats) {
        const selectedSubAgent = subAgentsList.find(subAgent => subAgent.userId === selectedSubAgentId);
        const position = subAgentsList.findIndex(subAgent => subAgent.userId === selectedSubAgentId) + 1;

        trackUserChatsSelect({
          userId: selectedSubAgentId as number,
          unreadCount: selectedSubAgent?.totalUnreadMessagesCount || 0,
          position,
          isMine: false,
        });
      }
    },
    [selectedSubAgentId, subAgentsList, unreadMessagesCount, userId],
  );
};
